<cass-calendar [daysSelected]="daysSelected" [issueDates]="issueDates" (daysSelectedChanged)="handleIssuesSelected($event)"></cass-calendar>